












import Vue from 'vue'
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options'
import { mapGetters, mapMutations } from 'vuex'
import { storeModuleName } from '@/store/modules/ui'

interface Data {}

interface Methods {
  changeCurrentImage: (increment: number) => void
  setCurrentGalleryPicture: (value: number) => void
  onKeyDown: (e: any) => void
}

interface Computed {
  picturesInGallery: Array<string>
  currentGalleryPicture: number
}

interface Props {}

export default Vue.extend({
  name: 'UiGallery',
  computed: {
    ...mapGetters(storeModuleName, ['picturesInGallery', 'currentGalleryPicture'])
  },
  watch: {
    picturesInGallery (val) {
      if (val.length > 0) {
        document.body.style.overflow = 'hidden'
        if (this.currentGalleryPicture < 0) {
          this.setCurrentGalleryPicture(0)
        }
      } else {
        document.body.style.overflow = 'auto'
        this.setCurrentGalleryPicture(-1)
      }
    }
  },
  created () {
    window.addEventListener('keydown', this.onKeyDown)
  },
  beforeDestroy () {
    window.removeEventListener('keydown', this.onKeyDown)
  },
  methods: {
    onKeyDown (e: any) {
      if (e.key === 'ArrowLeft') {
        this.changeCurrentImage(-1)
      } else if (e.key === 'ArrowRight') {
        this.changeCurrentImage(1)
      }
    },
    changeCurrentImage (increment: number) {
      const value = this.currentGalleryPicture + increment
      const length = this.picturesInGallery
      if (value < 0 || value > this.picturesInGallery.length - 1) {
        return
      }
      this.setCurrentGalleryPicture(value)
    },
    ...mapMutations(storeModuleName, ['setPicturesInGallery', 'setCurrentGalleryPicture'])
  }
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>)
